export const skills = [
  {
    name: "Html",
    image: "/images/skills/html.png",
  },
  {
    name: "Css",
    image: "/images/skills/css.png",
  },
  {
    name: "JavaScript",
    image: "/images/skills/javascript.png",
  },
  {
    name: "ReactJS",
    image: "/images/skills/react.png",
  },
  {
    name: "TypeScript",
    image: "/images/skills/typescript.png",
  },
  {
    name: "Redux",
    image: "/images/skills/redux.png",
  },

  {
    name: "React Native",
    image: "/images/skills/reactNative.png",
  },
  {
    name: "NodeJs",
    image: "/images/skills/nodejs.png",
  },
  {
    name: "MongoDB",
    image: "/images/skills/mongodb.png",
  },
  {
    name: "Figma",
    image: "/images/skills/figma.png",
  },
];
